import type { TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthor } from './tweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthor';
import type { TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfo } from './tweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfo';
import type { TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetEngagement } from './tweetListResponsePageAllOfThreeContentItemReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type TweetListResponsePageAllOfThreeContentItemReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetAuthor;
  basicInfo?: TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfo;
  engagement?: TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetEngagement;
};
